import React from 'react';
import { Card, Col, Container, Row } from 'reactstrap';
import SocialLinks from '../components/SocialLinks';

function About() {
  return (
    <Card className="section-lg bg-gradient-info shadow-lg border-0">
      <Container className="">
        <div className="p-2">
          <Row className="">
            <Col className="order-lg-2" lg="4">
              <img
                src="https://avatars.githubusercontent.com/u/50882838?v=4"
                style={{ width: '200px' }}
                alt=""
                className="rounded-circle img-center img-fluid shadow shadow-lg--hover mb-4"
              />
            </Col>
            <Col lg="8" className="order-lg-1">
              <h2 className="text-white">Reach Out to me!</h2>
              <p className="lead text-white mt-3">
                DISCUSS A PROJECT OR JUST WANT TO SAY HI? MY INBOX IS OPEN FOR ALL
              </p>
              <p className="text-white mt-3">Work less, think more...</p>
              <div className="my-3 icon-shape bg-gradient-white shadow rounded text-info">
                Dhaka, Bangladesh
              </div>
              <SocialLinks />
            </Col>
          </Row>
        </div>
      </Container>
    </Card>
  );
}

export default About;
